// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseFleetPlannerAreaRoutes = {
  route: '/fleet-planner',
  Campaigns: { route: '/campaigns' },
  Fleet: { route: '/fleet' },
}

export const FleetPlannerAreaRoutes = transformRoutes(
  BaseFleetPlannerAreaRoutes,
)
